"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

require("../styles/_active-campaign.scss");

var _Tags = _interopRequireDefault(require("../../../../../../../../../common/components/Tags"));

var _Post = _interopRequireDefault(require("./Post"));

var _PostLoader = _interopRequireDefault(require("./PostLoader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Campaign = /*#__PURE__*/function (_Component) {
  _inherits(Campaign, _Component);

  function Campaign() {
    var _this;

    _classCallCheck(this, Campaign);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Campaign).call(this));

    _defineProperty(_assertThisInitialized(_this), "openViewPostModalAction", (0, _lodash.default)(function (post) {
      return function () {
        var openViewPostModal = _this.props.openViewPostModal;
        return openViewPostModal(post);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function () {
      var _this$props = _this.props,
          history = _this$props.history,
          inspirationCampaignId = _this$props.campaign.inspirationCampaignId;
      history.push("/view/campaigns/".concat(inspirationCampaignId));
    });

    _this.state = {
      posts: void 0
    };
    return _this;
  }

  _createClass(Campaign, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchCampaign();
    }
  }, {
    key: "fetchCampaign",
    value: function () {
      var _fetchCampaign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props2, getCampaignPosts, fetchAssets, _ref, data, error, posts;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = this.props, getCampaignPosts = _this$props2.getCampaignPosts, fetchAssets = _this$props2.fetchAssets;
                _context.next = 3;
                return getCampaignPosts({
                  isPublic: true
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                error = _ref.error;
                posts = (0, _lodash2.default)(data, 'getInspirationPostsForCampaign', []) || [];

                if (!(error || !posts.length)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", void this.setState({
                  posts: posts
                }));

              case 9:
                fetchAssets(posts);
                this.setState({
                  posts: posts
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCampaign() {
        return _fetchCampaign.apply(this, arguments);
      }

      return fetchCampaign;
    }()
  }, {
    key: "renderPosts",
    value: function renderPosts() {
      var _this2 = this;

      var posts = this.state.posts;

      if (!posts) {
        return _react.default.createElement("div", {
          className: "active-campaign__container__post-loader"
        }, _react.default.createElement(_PostLoader.default, null), _react.default.createElement(_PostLoader.default, null), _react.default.createElement(_PostLoader.default, null));
      }

      if (!posts.length) {
        return _react.default.createElement("div", {
          className: "active-campaign__container__no-posts-placeholder"
        }, _react.default.createElement("div", {
          className: "active-campaign__container__no-posts-placeholder__wrapper"
        }, _react.default.createElement("p", null, "There are currently no Posts in this Campaign")));
      }

      return _react.default.createElement(_uiKit.Carousel, null, posts.map(function (post) {
        return _react.default.createElement(_Post.default, {
          key: post.inspirationId,
          post: post,
          onViewPost: _this2.openViewPostModalAction(post)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$campaign = this.props.campaign,
          name = _this$props$campaign.name,
          description = _this$props$campaign.description,
          coverImageKey = _this$props$campaign.coverImageKey,
          tags = _this$props$campaign.tags;
      return _react.default.createElement("div", {
        className: "active-campaign",
        style: {
          background: coverImageKey ? "linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(\"".concat(coverImageKey, "\")") : _vars.COLOURS.grey.nevada
        }
      }, _react.default.createElement("div", {
        className: "active-campaign__container"
      }, _react.default.createElement("div", {
        className: "active-campaign__container__upper-content"
      }, _react.default.createElement("div", {
        className: "active-campaign__container__upper-content__info"
      }, _react.default.createElement("p", {
        className: "active-campaign__container__upper-content__info__header"
      }, name), _react.default.createElement("p", {
        className: "active-campaign__container__upper-content__info__description"
      }, description)), _react.default.createElement(_uiKit.Button, {
        className: "post-details-form__video-details__upload-button",
        onClick: this.handleButtonClick
      }, "More Info")), tags ? _react.default.createElement(_Tags.default, {
        tags: tags
      }) : _react.default.createElement("div", {
        className: "active-campaign__container__tags-placeholder"
      }), this.renderPosts()));
    }
  }]);

  return Campaign;
}(_react.Component);

exports.default = Campaign;